module.exports = __webpack_public_path__ + "5fd34436cffb5b85fff31c4e892df121.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/bow.svg
// module id = FULv
// module chunks = 5